import { getStorageItem, setBrowserStorageItem } from '@/modules/@common/helpers/storage';

const SSO_EMAILS_STORAGE_NAME = 'SSO_EMAILS_STORAGE';

const ssoEmailStorageManager = {
  setEmails: (emails) => setBrowserStorageItem(SSO_EMAILS_STORAGE_NAME, JSON.stringify(emails)),
  getEmails: () => JSON.parse(getStorageItem(SSO_EMAILS_STORAGE_NAME)) || [],
};

export default ssoEmailStorageManager;
